import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"
const slugify = require('slugify');

const InteractivePlatformModule = ({
  key,
  sectionTitle=null,
  sectionContent=null,
  buckets=null,
  tabSections=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="platform-module">
      <div className="container">
        <div className="col-12 col-lg-10 tabs-wrap mx-auto">
          <div className="row">
            <div className="col-12 col-lg-10 text-center offset-lg-1">
              {sectionTitle &&
                <h2 className={ `content-title center ${sectionContent ? "orange-dash" : "mb4"}` }>{ htmlDecode(sectionTitle) }</h2>
              }
              {sectionContent &&
                <div className="section-content mb4" dangerouslySetInnerHTML={{ __html: sectionContent }} />
              }
            </div>
          </div>

          <div className="row">

            <div className="col-12 col-md-6 tabs-col">
              <ul className="nav nav-tabs" role="tablist">
                {tabSections && tabSections.map((section, index) => (
                    <li className="nav-item">
                      <a className={ `nav-link ${!index ? "active" : ""}` } href={ `#${slugify(section.tabTitle, {lower:true,remove:/[*+~.()'"!:@]/g})}` } role="tab" data-toggle="tab">
                        <div className="tab-icon-wrap">
                          <img src={section.tabIcon.url.includes(cdnUrl) ? section.tabIcon.url : cdnUrl + section.tabIcon.url} alt={ section.tabTitle } className="tab-icon" />
                          <img src={section.tabIconInverse.url.includes(cdnUrl) ? section.tabIconInverse.url : cdnUrl + section.tabIconInverse.url} alt={ section.tabTitle } className="tab-icon-inverse" />
                        </div>
                        { section.tabTitle }
                      </a>
                    </li>
                ))}
              </ul>
              <div className="buckets-wrap">
                {buckets && buckets.map((bucket) => (
                    <div className="bucket">{ bucket.bucketLabel }</div>
                ))}
              </div>
            </div>

            <div className="col-12 col-md-6 tab-content-col">
              <div className="tab-content">
                {tabSections && tabSections.map((section, index) => (
                    <div role="tabpanel" className={ `tab-pane ${!index ? "active" : ""}` } id={ slugify(section.tabTitle, {lower:true,remove:/[*+~.()'"!:@]/g}) }>
                      <h2 className="module-header mb2">{ section.tabTitle }</h2>
                      <div className="section-content" dangerouslySetInnerHTML={{ __html: section.tabContent }} />
                      {section.tabCtaButtonText && section.tabCtaButtonUrl &&
                      <Link href={ section.tabCtaButtonUrl } className="button inverse">{ section.tabCtaButtonText }</Link>
                      }
                    </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default InteractivePlatformModule
